(function () {
  const $s = window.$s;
  if (!$s) return;

  function initDropdown(container) {
    const btn = container.querySelector('.link-dropdown-trigger');
    const panel = container.querySelector('.link-dropdown-panel');
    if (!btn || !panel) return;
    const collapse = () => { btn.setAttribute('aria-expanded', 'false'); $s.collapse(panel, { duration: 200 }); };
    const expand = () => { btn.setAttribute('aria-expanded', 'true'); $s.expand(panel, { duration: 200 }); };
    btn.addEventListener('click', (e) => { e.stopPropagation(); btn.getAttribute('aria-expanded') === 'true' ? collapse() : expand(); });
    document.addEventListener('click', (e) => { if (!container.contains(e.target) && btn.getAttribute('aria-expanded') === 'true') collapse(); });
  }

  function initAll() {
    document.querySelectorAll('.title-link-selector [data-dropdown]').forEach(initDropdown);
  }

  initAll();

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.title-link-selector [data-dropdown]').forEach(initDropdown);
  });
})();
